<template lang="html">
  <div>
    <v-tooltip bottom>
      <v-btn flat icon v-if="enabled && small" @click="dialogo=true">
        <v-icon small slot="activator">fas fa-exchange-alt</v-icon>
        <span>Cambiar de grupo y/o propietario</span>
      </v-btn>
    </v-tooltip>
    <v-tooltip bottom>
      <v-btn color="info" v-if="enabled && !small" block slot="activator" @click="dialogo=true">
        <v-icon>fas fa-exchange-alt</v-icon>
        &nbsp;
        Propiedad
      </v-btn>
      <span>Cambiar de grupo y/o propietario</span>
    </v-tooltip>

    <v-dialog v-model="dialogo" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>Cambio de Propietario</h4>
        </v-card-title>
        <v-divider></v-divider>
        <v-form v-model="valido" ref="form">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-subheader v-text="'Grupo'"></v-subheader>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  :items="grupos"
                  :item-value="'id'"
                  :item-text="'name'"
                  v-model="selectedGroup"
                  label="Seleccione"
                  autocomplete hint="Teclee para buscar el grupo"
                  :search-input.sync="search"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6>
                <v-subheader v-text="'Usuario'"></v-subheader>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  :items="usuarios"
                  :item-value="'id'"
                  :item-text="'username'"
                  v-model="selectedUser"
                  label="Seleccione"
                  autocomplete hint="Teclee para buscar el usuario"
                  :search-input.sync="searchUsers"
                  required
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-btn color="primary" @click.stop="submit()">
            <v-icon left small>fas fa-exchange-alt</v-icon>
            Aceptar
          </v-btn>
          <v-btn flat @click.stop="dialogo=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import Grupos from '../../services/grupos'
import Usuarios from '../../services/usuarios'
import * as _ from 'lodash'

export default {
  name: 'Ownership',
  props: ['objeto', 'small'],
  inject: ['servicio'],
  data () {
    return {
      enabled: false,
      dialogo: false,
      valido: true,
      grupos: [],
      usuarios: [],
      selectedGroup: null,
      selectedUser: null,
      loadingGrupos: false,
      loadingUsuarios: true,
      search: null,
      searchUsers: null
    }
  },
  watch: {
    search (val) {
      val && this.getGrupos(val)
    },
    searchUsers (val) {
      val && this.getUsuarios(val)
    }
  },
  methods: {
    async submit () {
      let registro = {id: this.objeto.id}
      registro.group = this.selectedGroup
      registro.propietario = this.selectedUser
      registro = await this.servicio.ownership(registro)
      this.$emit('update-ownership', registro)
    },
    getGrupos: _.debounce(async function (val) {
      this.loadingGrupos = true
      if (val.length >= 3) {
        this.grupos = await Grupos.list(
          {
            populate: 'usuarioCreacion',
            select: 'name',
            where: JSON.stringify({ name: { contains: val } })
          })
        this.loadingGrupos = false
      }
    }, 500),
    getUsuarios: _.debounce(async function (val) {
      this.loadingUsuarios = true
      if (val.length >= 3) {
        this.usuarios = await Usuarios.list(
          {
            populate: 'usuarioCreacion',
            select: 'username',
            where: JSON.stringify({ username: { contains: val } })
          })
        this.loadingUsuarios = false
      }
    }, 500)
  },
  async beforeMount() {
    if (this.objeto && this.servicio) {
      this.selectedGroup = this.objeto.group
      this.selectedUser = this.objeto.propietario
      this.enabled = true
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/shared/OwnershipComponent.vue